import { type Fandom } from "@prisma/client";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { HorizontalScrollBar } from "~/components/Components/HorizontalScrollBar/HorizontalScrollBar";

type Props = {
  joinedFandoms: Fandom[];
};

export const MyPageJoinedFandomsModule = (props: Props) => {
  const router = useRouter();
  return (
    <HorizontalScrollBar listBarClassName="gap-[16px] pl-[20px] pt-[10px] pr-[24px] pb-[20px] !items-start">
      {props.joinedFandoms.map((fandom) => (
        <Link
          scroll={false}
          key={fandom.id}
          href={`/fandom/${fandom.id}`}
          className="flex h-fit w-[80px] flex-col items-center gap-[10px]"
        >
          <div className="relative h-[80px] w-[80px] rounded-full">
            <Image
              alt={fandom.title}
              className="rounded-full"
              fill
              objectFit="cover"
              src={`${fandom.imageUrl}`}
            />
          </div>
          <div className="flex max-h-[32px] w-full items-center justify-center">
            <p className="multi-line-truncate w-full overflow-visible whitespace-pre-wrap break-words text-center text-[13px] font-medium leading-[16px]">
              {fandom.title}
            </p>
          </div>
        </Link>
      ))}
    </HorizontalScrollBar>
  );
};
